import React from "react";
import LocationSelector from "../components/LocationSelector";

function LocationList() {
  return <LocationSelector />;
}

export default LocationList;
